



































































































import { Component, Vue } from 'vue-property-decorator';
import AppBreadcrumbs from '@/components/App/AppBreadcrumbs.vue';
import GoBackButton from '@/components/App/GoBackButton.vue';
import env from '@/env';
import FetchingBar from '@/components/App/FetchingBar.vue';

type Link = {
  icon: string;
  label: string;
  route: string;
  adminOnly?: boolean;
};

@Component({
  components: {
    FetchingBar,
    GoBackButton,
    AppBreadcrumbs
  }
})
export default class AppNavbar extends Vue {
  private drawer = true;

  loginDialog = false;

  env = env;

  get user() {
    return this.$store.state.user;
  }

  get displayedLinks() {
    return this.links.filter((link) => !this.$store.getters.restrictedUser || !link.adminOnly);
  }

  private links: Link[] = [
    {
      icon: 'mdi-clipboard-text',
      label: 'Cutoverpläne',
      route: '/'
    },
    {
      icon: 'mdi-tag-multiple',
      label: 'Attribute',
      route: '/attributes',
      adminOnly: true
    },
    {
      icon: 'mdi-dns',
      label: 'Blueprints',
      route: '/blueprints',
      adminOnly: true
    },
    /*    {
      icon: 'mdi-grain',
      label: 'Matrix',
      route: '/matrix',
      adminOnly: true
    }, */
    {
      icon: 'mdi-earth',
      label: 'Umgebungen',
      route: '/environment',
      adminOnly: true
    },
    {
      icon: 'mdi-clock',
      label: 'Phasen',
      route: '/phase',
      adminOnly: true
    },
    {
      icon: 'mdi-account-multiple',
      label: 'Ansprechpartner',
      route: '/responsible',
      adminOnly: false
    },
    {
      icon: 'mdi-waves',
      label: 'Wellen',
      route: '/wave',
      adminOnly: true
    }
  ];

  private adminLinks: Link[] = [
    {
      icon: 'mdi-account',
      label: 'Benutzer',
      route: '/users'
    }
  ];
}
